// @flow
import styled from 'styled-components'
import { oedu_white, oedu_red } from '../../styles/base'

// --- Company List ---
export const TableSearch = styled.div`
	padding: 8px;
	border-radius: 6px;
	background: ${oedu_white};
	box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
`

export const TableInput = {
  width: 130,
  marginRight: 8
}

export const TableKey = styled.span`
	color: ${oedu_red};
	button{
	  float: right;
	}
`

export const TableDate = styled.section`
	display: flex;
	justify-content: space-between;
	align-items: center;
	& span, strong {
		font-size: 12px;
	}
`



// WEBPACK FOOTER //
// ./src/components/table-earnings/style.js